function CricketBall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <defs>
            <circle id="SVGID_1_" cx="256" cy="256" r="200"></circle>
          </defs>
          <use fill="#E53935" overflow="visible" xlinkHref="#SVGID_1_"></use>
          <clipPath id="SVGID_2_">
            <use overflow="visible" xlinkHref="#SVGID_1_"></use>
          </clipPath>
          <g
            fill="none"
            stroke="#FFECB3"
            strokeMiterlimit="10"
            strokeWidth="5"
            clipPath="url(#SVGID_2_)"
          >
            <path d="M293.5 64L293.5 75"></path>
            <path strokeDasharray="23,12" d="M293.5 87L293.5 431"></path>
            <path d="M293.5 437L293.5 448"></path>
          </g>
          <g
            fill="none"
            stroke="#FFECB3"
            strokeMiterlimit="10"
            strokeWidth="5"
            clipPath="url(#SVGID_2_)"
          >
            <path d="M307.5 64L307.5 75"></path>
            <path strokeDasharray="23,12" d="M307.5 87L307.5 431"></path>
            <path d="M307.5 437L307.5 448"></path>
          </g>
          <g
            fill="none"
            stroke="#FFECB3"
            strokeMiterlimit="10"
            strokeWidth="5"
            clipPath="url(#SVGID_2_)"
          >
            <path d="M204.5 64L204.5 75"></path>
            <path strokeDasharray="23,12" d="M204.5 87L204.5 431"></path>
            <path d="M204.5 437L204.5 448"></path>
          </g>
          <g
            fill="none"
            stroke="#FFECB3"
            strokeMiterlimit="10"
            strokeWidth="5"
            clipPath="url(#SVGID_2_)"
          >
            <path d="M218.5 64L218.5 75"></path>
            <path strokeDasharray="23,12" d="M218.5 87L218.5 431"></path>
            <path d="M218.5 437L218.5 448"></path>
          </g>
          <g clipPath="url(#SVGID_2_)">
            <path
              fill="#C62828"
              d="M241.255 49.366H270.745V462.86H241.255z"
            ></path>
            <g
              fill="none"
              stroke="#FFECB3"
              strokeMiterlimit="10"
              strokeWidth="5"
            >
              <path d="M270.745 451.445L270.745 462.86 259.33 462.86"></path>
              <path d="M252.67 462.86L241.255 462.86 241.255 451.445"></path>
              <path
                strokeDasharray="22.2659,12.145"
                d="M241.255 439.3L241.255 66.853"
              ></path>
              <path d="M241.255 60.78L241.255 49.366 252.67 49.366"></path>
              <path d="M259.33 49.366L270.745 49.366 270.745 60.78"></path>
              <path
                strokeDasharray="22.2659,12.145"
                d="M270.745 72.925L270.745 445.373"
              ></path>
            </g>
          </g>
          <g>
            <path
              fill="#424242"
              d="M256 70c49.683 0 96.391 19.347 131.522 54.478S442 206.317 442 256s-19.347 96.391-54.478 131.522S305.683 442 256 442s-96.391-19.347-131.522-54.478S70 305.683 70 256s19.347-96.391 54.478-131.522S206.317 70 256 70m0-14C145.543 56 56 145.543 56 256s89.543 200 200 200 200-89.543 200-200S366.457 56 256 56z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CricketBall;
